import Textarea from 'components/FormElements/Textarea/Textarea';
import Modal from 'components/Modal/Modal';
import useHomeQuickModal from "./useHomeQuickModal";
import './HomeQuickModal.scss';
import Input from 'components/FormElements/Input/Input';

const HomeQuickModal = ({ open, onClose }) => {
  const {
    submit,
  } = useHomeQuickModal({ onClose });

  return (
    <Modal
      className='home-quick-modal modal--large'
      show={open}
      onCancel={onClose}
      // header='Quick Modal'
      footer={
        <>
          <span className='action' onClick={() => onClose()}>Cancel</span>
          <span className='separator'></span>
          <span className='action' onClick={(e) => submit(e)}><strong>Save</strong></span>
        </>
      }
    >
      <div>
        <p className='mid'>auto generated copy/paste list:</p>
        <p>
          ✅ diet <br />
          ✅ workout <br />
          ✅ track calories <br />
          ✅ walk <br />
          ✅ meditation <br />
          ✅ app / album <br />
          ✅ set stage
        </p>

        <p className='mid'>able to select from common/saved things:</p>
        <Textarea
          label='Diet / Calories'
          value=''
          onChange={(e) => {}}
          rows={12}
        />

        <div className='form-group form-group--two-column'>
          <Input
            id="exerciseHours"
            label="Exercise:"
            min={0}
            type='number'
            placeholder="Hours"
            // value={dayDetails.exerciseHours}
            // onChange={(e) => setDayDetails(prev => ({ ...prev, exerciseHours: e.target.value }))}
          />
          <Input
            type='number'
            id="exerciseMinutes"
            placeholder="Minutes"
            min={0}
            max={59}
            // value={dayDetails.exerciseMinutes}
            // onChange={(e) => setDayDetails(prev => ({ ...prev, exerciseMinutes: e.target.value }))}
          />
        </div>

      </div>
    </Modal>
  );
};

export default HomeQuickModal;